var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from '../../utils/styled-components';
import Label from '../Label';
import formTheme from '../theme';
import { ComponentThemeProvider } from '../../ThemeProvider';
import Skeleton, { withSkeleton } from '../../Skeleton';
var getBorderColor = function (_a, error) {
    var checkbox = _a.component.form.checkbox;
    return (error ? checkbox.error.borderColor : checkbox.borderColor);
};
var getFocusBorderColor = function (_a, error) {
    var checkbox = _a.component.form.checkbox;
    return (error ? checkbox.error.borderColor : checkbox.focus.borderColor);
};
var getSelectedBorderColor = function (_a, error) {
    var checkbox = _a.component.form.checkbox;
    return (error ? checkbox.error.borderColor : checkbox.checked.borderColor);
};
var getCheckmarkColor = function (_a, error) {
    var checkbox = _a.component.form.checkbox;
    return (error ? checkbox.checkMark.error.color : checkbox.checkMark.color);
};
/**
 * the top/left offsets aren't correct anymore if the border width of the input changes
 * so the correct values are calculated here
 */
var calculateFocusOffsetStyles = function (theme) {
    var checkMarkTheme = theme.component.form.checkbox.checkMark;
    var defaultTop = parseFloat(checkMarkTheme.top);
    var defaultLeft = parseFloat(checkMarkTheme.left);
    var defaultBorderWidth = parseFloat(theme.component.form.checkbox.borderWidth);
    var focusBorderWidth = parseFloat(theme.component.form.checkbox.focus.borderWidth);
    var diff = focusBorderWidth - defaultBorderWidth;
    return "\n    top: " + (defaultTop - diff) + (checkMarkTheme.top.endsWith('px') ? 'px' : 'rem') + ";\n    left: " + (defaultLeft - diff) + (checkMarkTheme.left.endsWith('px') ? 'px' : 'rem') + ";\n    ";
};
var getBackgroundStyling = function (_a, error) {
    var checkbox = _a.component.form.checkbox;
    if (error) {
        return "\n  background-color: " + checkbox.error.backgroundColor + ";\n        ";
    }
    return "\n      background-color: " + checkbox.backgroundColor + ";\n        ";
};
var Input = styled.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* disable default styling */\n  outline: none;\n  appearance: none;\n\n  width: ", ";\n  height: ", ";\n\n  border-radius: 0.1875rem;\n  box-shadow: ", ";\n\n  border: solid ", "\n    ", ";\n\n  ", "\n\n  &:checked {\n    border-color: ", ";\n    &::after {\n      position: relative;\n      top: ", ";\n      left: ", ";\n      display: block;\n      width: ", ";\n      height: ", ";\n      border-width: 0 ", "\n        ", " 0;\n      border-style: solid;\n      border-color: ", ";\n      transform: rotate(45deg);\n      content: '';\n      box-sizing: content-box;\n    }\n  }\n\n  /* focus state */\n  &:focus,\n  &.focus {\n    cursor: pointer;\n    border: ", " solid\n      ", ";\n    &:checked {\n      border-color: ", ";\n    }\n    &::after {\n      ", "\n    }\n  }\n\n  /* disabled state */\n  &:disabled {\n    background-color: ", ";\n    border-color: ", ";\n    &:checked {\n      &::after {\n        border-color: ", ";\n        top: ", ";\n        left: ", ";\n      }\n    }\n  }\n"], ["\n  /* disable default styling */\n  outline: none;\n  appearance: none;\n\n  width: ", ";\n  height: ", ";\n\n  border-radius: 0.1875rem;\n  box-shadow: ", ";\n\n  border: solid ", "\n    ", ";\n\n  ", "\n\n  &:checked {\n    border-color: ", ";\n    &::after {\n      position: relative;\n      top: ", ";\n      left: ", ";\n      display: block;\n      width: ", ";\n      height: ", ";\n      border-width: 0 ", "\n        ", " 0;\n      border-style: solid;\n      border-color: ", ";\n      transform: rotate(45deg);\n      content: '';\n      box-sizing: content-box;\n    }\n  }\n\n  /* focus state */\n  &:focus,\n  &.focus {\n    cursor: pointer;\n    border: ", " solid\n      ", ";\n    &:checked {\n      border-color: ", ";\n    }\n    &::after {\n      ", "\n    }\n  }\n\n  /* disabled state */\n  &:disabled {\n    background-color: ", ";\n    border-color: ", ";\n    &:checked {\n      &::after {\n        border-color: ", ";\n        top: ", ";\n        left: ", ";\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.component.form.checkbox.width;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.form.checkbox.height;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.form.checkbox.shadow;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.form.checkbox.borderWidth;
}, function (_a) {
    var theme = _a.theme, error = _a.error;
    return getBorderColor(theme, error);
}, function (_a) {
    var theme = _a.theme, error = _a.error;
    return getBackgroundStyling(theme, error);
}, function (_a) {
    var theme = _a.theme, error = _a.error;
    return getSelectedBorderColor(theme, error);
}, function (_a) {
    var theme = _a.theme;
    return theme.component.form.checkbox.checkMark.top;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.form.checkbox.checkMark.left;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.form.checkbox.checkMark.width;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.form.checkbox.checkMark.height;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.form.checkbox.checkMark.borderWidth;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.form.checkbox.checkMark.borderWidth;
}, function (_a) {
    var theme = _a.theme, error = _a.error;
    return getCheckmarkColor(theme, error);
}, function (_a) {
    var theme = _a.theme;
    return theme.component.form.checkbox.focus.borderWidth;
}, function (_a) {
    var theme = _a.theme, error = _a.error;
    return getFocusBorderColor(theme, error);
}, function (_a) {
    var theme = _a.theme, error = _a.error;
    return getSelectedBorderColor(theme, error);
}, function (_a) {
    var theme = _a.theme;
    return calculateFocusOffsetStyles(theme);
}, function (_a) {
    var theme = _a.theme;
    return theme.component.form.checkbox.disabled.backgroundColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.form.checkbox.disabled.borderColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.form.checkbox.checkMark.disabled.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.form.checkbox.checkMark.top;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.form.checkbox.checkMark.left;
});
var Checkbox = function (_a) {
    var className = _a.className, label = _a.label, error = _a.error, onChange = _a.onChange, checked = _a.checked, defaultChecked = _a.defaultChecked, disabled = _a.disabled;
    return (React.createElement(ComponentThemeProvider, { theme: formTheme },
        React.createElement(Label, { className: className, inline: true },
            React.createElement(Input, { type: "checkbox", error: error, onChange: onChange, checked: checked, defaultChecked: defaultChecked, disabled: disabled, className: className }),
            label)));
};
export var CheckboxSkeleton = function () { return (React.createElement(ComponentThemeProvider, { theme: formTheme },
    React.createElement(Label, { inline: true },
        React.createElement(Input, { type: "checkbox" }),
        React.createElement(Skeleton, { height: "1.125rem", inline: true, width: "70%" })))); };
export default withSkeleton(Checkbox, CheckboxSkeleton);
var templateObject_1;
//# sourceMappingURL=index.js.map